import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
/* © 2023 Promethean. All Rights Reserved.
 *
 * Unauthorized copying of this file or any part of this file
 * via any medium is strictly prohibited.
 */
import React, { useRef, useState } from 'react';
import { Divider } from '@mui/material';
import useMediaQuery from '@mui/material/useMediaQuery';
import { useIntl } from 'react-intl';
import { StyledFooter, StyledAccordion, StyledAccordionSummary, StyledAccordionDetails } from './footerStyles';
import { EmbersLink } from '../link/link';
import { SKIP_TO_MAIN_CONTENT_ID } from '../header';
import { PROMETHEAN_BREAKPOINT_SM, PROMETHEAN_BREAKPOINT_MD } from '../styles/breakpoints/breakpoints';
import EA_icon from './assets/eA_icon.svg';
import { onEnterKeyPress } from '../utils/wcagUtils';
export var EmbersFooter = function EmbersFooter(props) {
  var copyRightYear = props.copyRightYear,
    _props$languageCode = props.languageCode,
    languageCode = _props$languageCode === void 0 ? 'en' : _props$languageCode,
    className = props.className,
    role = props.role,
    _props$tabIndex = props.tabIndex,
    tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
    skipTo = props.skipTo,
    eulaLink = props.eulaLink,
    cookieLink = props.cookieLink,
    mixpanelProps = props.mixpanelProps;
  var tracker = mixpanelProps === null || mixpanelProps === void 0 ? void 0 : mixpanelProps.tracker;
  var intl = useIntl();
  var portrait = useMediaQuery("(max-width:".concat(PROMETHEAN_BREAKPOINT_MD, "px)"));
  var mobile = useMediaQuery("(max-width:".concat(PROMETHEAN_BREAKPOINT_SM, "px)"));
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    supportExpanded = _useState2[0],
    setSupportExpanded = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    policyExpanded = _useState4[0],
    setPolicyExpanded = _useState4[1];

  // prevent mui-expand text width flicker caused by min-width
  var _useState5 = useState(''),
    _useState6 = _slicedToArray(_useState5, 2),
    supportAccordionClass = _useState6[0],
    setSupportAccordionClass = _useState6[1];
  var supportAccordionClassRef = useRef('');
  var _useState7 = useState(''),
    _useState8 = _slicedToArray(_useState7, 2),
    policyAccordionClass = _useState8[0],
    setPolicyAccordionClass = _useState8[1];
  var openPage = function openPage(url) {
    window.open(url);
  };
  var handleOpenEA = function handleOpenEA() {
    var _tracker$mixpanelTrac;
    tracker === null || tracker === void 0 || (_tracker$mixpanelTrac = tracker.mixpanelTrackHelper) === null || _tracker$mixpanelTrac === void 0 || _tracker$mixpanelTrac.call(tracker, 'Click Essential Accountability');
    openPage('https://www.levelaccess.com/prometheanworld/');
  };
  var handleOpenSocial = function handleOpenSocial(media) {
    var _tracker$mixpanelTrac2;
    tracker === null || tracker === void 0 || (_tracker$mixpanelTrac2 = tracker.mixpanelTrackHelper) === null || _tracker$mixpanelTrac2 === void 0 || _tracker$mixpanelTrac2.call(tracker, 'Click Social Link', {
      Media: media
    });
    switch (media) {
      case 'Facebook':
        {
          openPage('https://www.facebook.com/PrometheanWorld');
          break;
        }
      case 'Twitter':
        {
          openPage('https://twitter.com/promethean');
          break;
        }
      case 'LinkedIn':
        {
          openPage('https://www.linkedin.com/company/promethean');
          break;
        }
      default:
        break;
    }
  };
  return /*#__PURE__*/React.createElement(StyledFooter, {
    id: skipTo ? SKIP_TO_MAIN_CONTENT_ID : void 0,
    role: role || 'contentinfo',
    className: "".concat(className !== null && className !== void 0 ? className : '', "\n        ").concat(mobile ? 'EmbersFooter-root EmbersFooter-mobile' : portrait ? 'EmbersFooter-root EmbersFooter-tablet' : 'EmbersFooter-root')
  }, /*#__PURE__*/React.createElement("div", {
    className: "EmbersFooter-content"
  }, /*#__PURE__*/React.createElement("div", {
    className: "EmbersFooter-body"
  }, /*#__PURE__*/React.createElement("div", {
    className: "EmbersFooter-links"
  }, /*#__PURE__*/React.createElement(StyledAccordion, {
    disableGutters: true,
    elevation: 0,
    square: true,
    expanded: supportExpanded,
    "aria-controls": "footer-support-details",
    onChange: function onChange() {
      var _document$getElementB;
      var target = (_document$getElementB = document.getElementById('footer-support')) === null || _document$getElementB === void 0 ? void 0 : _document$getElementB.parentElement;
      if (target) {
        var _target$getAttribute;
        if (target !== null && target !== void 0 && (_target$getAttribute = target.getAttribute('class')) !== null && _target$getAttribute !== void 0 && _target$getAttribute.includes('portalAccordion-expanded')) {
          setTimeout(function () {
            setSupportAccordionClass(supportAccordionClassRef.current);
          }, 100);
        } else {
          supportAccordionClassRef.current = (target === null || target === void 0 ? void 0 : target.getAttribute('class')) || '';
          setSupportAccordionClass("".concat(supportAccordionClassRef.current, " portalAccordion-expanded"));
        }
      }
      setSupportExpanded(!supportExpanded);
    },
    className: supportAccordionClass
  }, /*#__PURE__*/React.createElement(StyledAccordionSummary, {
    id: "footer-support",
    role: "button",
    "aria-expanded": supportExpanded,
    "aria-label": intl.formatMessage({
      id: 'embers.footer.support',
      defaultMessage: 'Support'
    }),
    "aria-haspopup": "listbox",
    expandIcon: /*#__PURE__*/React.createElement("span", {
      className: 'icon-expand-more'
    }),
    tabIndex: tabIndex
  }, intl.formatMessage({
    id: 'embers.footer.support',
    defaultMessage: 'Support'
  }).toUpperCase()), /*#__PURE__*/React.createElement(StyledAccordionDetails, {
    role: "list",
    id: "footer-support-details",
    className: "EmbersFooter-support"
  }, /*#__PURE__*/React.createElement("div", {
    role: "listitem"
  }, /*#__PURE__*/React.createElement(EmbersLink, {
    className: "EmbersFooter-link",
    mode: "white",
    href: "https://support.prometheanworld.com/s/community?lang=".concat(languageCode),
    onClick: function onClick() {
      var _tracker$mixpanelTrac3;
      return tracker === null || tracker === void 0 || (_tracker$mixpanelTrac3 = tracker.mixpanelTrackHelper) === null || _tracker$mixpanelTrac3 === void 0 ? void 0 : _tracker$mixpanelTrac3.call(tracker, 'Community Support');
    },
    rel: "noreferrer",
    target: "_blank",
    tabIndex: tabIndex,
    "aria-label": intl.formatMessage({
      id: 'embers.accessibility.opensNewPage.label',
      defaultMessage: '{link} (opens in new page)'
    }, {
      link: intl.formatMessage({
        id: 'embers.footer.support.community',
        defaultMessage: 'Community'
      })
    })
  }, intl.formatMessage({
    id: 'embers.footer.support.community',
    defaultMessage: 'Community'
  }))), /*#__PURE__*/React.createElement("div", {
    role: "listitem"
  }, /*#__PURE__*/React.createElement(EmbersLink, {
    className: "EmbersFooter-link",
    mode: "white",
    href: "https://support.prometheanworld.com/s/contact-us?language=".concat(languageCode),
    onClick: function onClick() {
      var _tracker$mixpanelTrac4;
      return tracker === null || tracker === void 0 || (_tracker$mixpanelTrac4 = tracker.mixpanelTrackHelper) === null || _tracker$mixpanelTrac4 === void 0 ? void 0 : _tracker$mixpanelTrac4.call(tracker, 'Contact Support');
    },
    rel: "noreferrer",
    target: "_blank",
    tabIndex: tabIndex,
    "aria-label": intl.formatMessage({
      id: 'embers.accessibility.opensNewPage.label',
      defaultMessage: '{link} (opens in new page)'
    }, {
      link: intl.formatMessage({
        id: 'embers.footer.support.contact',
        defaultMessage: 'Contact Support'
      })
    })
  }, intl.formatMessage({
    id: 'embers.footer.support.contact',
    defaultMessage: 'Contact Support'
  }))))), /*#__PURE__*/React.createElement(StyledAccordion, {
    disableGutters: true,
    elevation: 0,
    square: true,
    expanded: policyExpanded,
    "aria-controls": "footer-policy-details",
    onChange: function onChange() {
      var _document$getElementB2;
      var target = (_document$getElementB2 = document.getElementById('footer-policy')) === null || _document$getElementB2 === void 0 ? void 0 : _document$getElementB2.parentElement;
      if (target) {
        var _target$getAttribute2;
        if (target !== null && target !== void 0 && (_target$getAttribute2 = target.getAttribute('class')) !== null && _target$getAttribute2 !== void 0 && _target$getAttribute2.includes('portalAccordion-expanded')) {
          setTimeout(function () {
            setPolicyAccordionClass('');
          }, 100);
        } else {
          setPolicyAccordionClass('portalAccordion-expanded');
        }
      }
      setPolicyExpanded(!policyExpanded);
    },
    className: policyAccordionClass
  }, /*#__PURE__*/React.createElement(StyledAccordionSummary, {
    id: "footer-policy",
    "aria-label": intl.formatMessage({
      id: 'embers.footer.policies',
      defaultMessage: 'Policies'
    }),
    role: "button",
    "aria-expanded": policyExpanded,
    "aria-haspopup": "listbox",
    expandIcon: /*#__PURE__*/React.createElement("span", {
      className: 'icon-expand-more'
    }),
    tabIndex: tabIndex
  }, intl.formatMessage({
    id: 'embers.footer.policies',
    defaultMessage: 'Policies'
  }).toUpperCase()), /*#__PURE__*/React.createElement(StyledAccordionDetails, {
    role: "list",
    id: "footer-policy-details",
    className: "EmbersFooter-policy"
  }, /*#__PURE__*/React.createElement("div", {
    role: "listitem"
  }, /*#__PURE__*/React.createElement(EmbersLink, {
    className: "EmbersFooter-link",
    mode: "white",
    href: eulaLink ? eulaLink !== null && eulaLink !== void 0 && eulaLink.includes('lang=') ? eulaLink : "".concat(eulaLink, "?lang=").concat(languageCode) : "https://one.prometheanworld.com/eula/web?lang=".concat(languageCode),
    onClick: function onClick() {
      var _tracker$viewEula;
      return tracker === null || tracker === void 0 || (_tracker$viewEula = tracker.viewEula) === null || _tracker$viewEula === void 0 ? void 0 : _tracker$viewEula.call(tracker, 'footer');
    },
    rel: "noreferrer",
    target: "_blank",
    tabIndex: tabIndex,
    "aria-label": intl.formatMessage({
      id: 'embers.accessibility.opensNewPage.label',
      defaultMessage: '{link} (opens in new page)'
    }, {
      link: intl.formatMessage({
        id: 'embers.footer.eula',
        defaultMessage: 'End User License Agreement & Privacy Statement'
      })
    })
  }, intl.formatMessage({
    id: 'embers.footer.eula',
    defaultMessage: 'End User License Agreement & Privacy Statement'
  }))), /*#__PURE__*/React.createElement("div", {
    role: "listitem"
  }, /*#__PURE__*/React.createElement(EmbersLink, {
    className: "EmbersFooter-link",
    mode: "white",
    href: cookieLink ? cookieLink !== null && cookieLink !== void 0 && cookieLink.includes('lang=') ? cookieLink : "".concat(cookieLink, "?lang=").concat(languageCode) : "https://one.prometheanworld.com/opensourcesoftwareandcookies?lang=".concat(languageCode),
    onClick: function onClick() {
      var _tracker$mixpanelTrac5;
      return tracker === null || tracker === void 0 || (_tracker$mixpanelTrac5 = tracker.mixpanelTrackHelper) === null || _tracker$mixpanelTrac5 === void 0 ? void 0 : _tracker$mixpanelTrac5.call(tracker, 'View Cookie Policy');
    },
    rel: "noreferrer",
    target: "_blank",
    tabIndex: tabIndex,
    "aria-label": intl.formatMessage({
      id: 'embers.accessibility.opensNewPage.label',
      defaultMessage: '{link} (opens in new page)'
    }, {
      link: intl.formatMessage({
        id: 'embers.footer.cookiePolicy',
        defaultMessage: 'Cookie Policy'
      })
    })
  }, intl.formatMessage({
    id: 'embers.footer.cookiePolicy',
    defaultMessage: 'Cookie Policy'
  })))))), /*#__PURE__*/React.createElement("ul", {
    className: "EmbersFooter-social"
  }, /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("div", {
    tabIndex: tabIndex,
    className: "icon-social icon-social-facebook",
    onKeyDown: function onKeyDown(e) {
      return onEnterKeyPress(e, function () {
        return handleOpenSocial('Facebook');
      });
    },
    onClick: function onClick() {
      return handleOpenSocial('Facebook');
    },
    role: "link",
    "aria-label": intl.formatMessage({
      id: 'embers.accessibility.opensNewPage.label',
      defaultMessage: '{link} (opens in new page)'
    }, {
      link: 'Facebook'
    })
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("div", {
    tabIndex: tabIndex,
    className: "icon-social icon-social-twitter",
    onKeyDown: function onKeyDown(e) {
      return onEnterKeyPress(e, function () {
        return handleOpenSocial('Twitter');
      });
    },
    onClick: function onClick() {
      return handleOpenSocial('Twitter');
    },
    role: "link",
    "aria-label": intl.formatMessage({
      id: 'embers.accessibility.opensNewPage.label',
      defaultMessage: '{link} (opens in new page)'
    }, {
      link: 'Twitter'
    })
  })), /*#__PURE__*/React.createElement("li", null, /*#__PURE__*/React.createElement("div", {
    tabIndex: tabIndex,
    className: "icon-social icon-social-linkedin",
    onKeyDown: function onKeyDown(e) {
      return onEnterKeyPress(e, function () {
        return handleOpenSocial('LinkedIn');
      });
    },
    onClick: function onClick() {
      return handleOpenSocial('LinkedIn');
    },
    role: "link",
    "aria-label": intl.formatMessage({
      id: 'embers.accessibility.opensNewPage.label',
      defaultMessage: '{link} (opens in new page)'
    }, {
      link: 'LinkedIn'
    })
  })))), /*#__PURE__*/React.createElement(Divider, {
    "aria-hidden": true
  }), /*#__PURE__*/React.createElement("div", {
    className: "EmbersFooter-body EmbersFooter-bottom"
  }, /*#__PURE__*/React.createElement("span", {
    className: "EmbersFooter-copyright"
  }, intl.formatMessage({
    id: 'embers.footer.copyright',
    defaultMessage: '©{copyRightYear} PROMETHEAN LIMITED. ALL RIGHTS RESERVED.'
  }, {
    copyRightYear: copyRightYear
  })), /*#__PURE__*/React.createElement("a", {
    className: "EmbersFooter-eA",
    tabIndex: tabIndex,
    "aria-labelledby": "accessibility-icon",
    onKeyDown: function onKeyDown(e) {
      return onEnterKeyPress(e, handleOpenEA);
    },
    onClick: handleOpenEA,
    href: "https://www.levelaccess.com/prometheanworld/",
    rel: "noreferrer",
    target: "_blank"
  }, /*#__PURE__*/React.createElement("img", {
    id: "accessibility-icon",
    src: EA_icon,
    "aria-hidden": true,
    alt: intl.formatMessage({
      id: 'embers.accessibility.opensNewPage.label',
      defaultMessage: '{link} (opens in new page)'
    }, {
      link: intl.formatMessage({
        id: 'embers.footer.eaIcon.alt',
        defaultMessage: 'Level Access website accessibility icon'
      })
    })
  })))));
};